import { create } from "zustand";
import { persist } from "zustand/middleware";

const STORAGE_KEY = "image-library-storage";
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export const useImageLibraryStore = create(
  persist(
    (set, get) => ({
      images: [],
      lastFetched: null,
      isLoading: false,

      // Check if cache is valid
      isCacheValid: () => {
        const { lastFetched } = get();
        if (!lastFetched) return false;
        return Date.now() - lastFetched < CACHE_TTL;
      },

      // Set images with timestamp
      setImages: (images) =>
        set({
          images,
          lastFetched: Date.now(),
          isLoading: false,
        }),

      // Invalidate cache (call after image generation)
      invalidateCache: () => set({ lastFetched: null }),

      // Add single image to cache (optimistic update)
      addImage: (image) =>
        set((state) => ({
          images: [image, ...state.images],
        })),

      // Remove image from cache
      removeImage: (imageId) =>
        set((state) => ({
          images: state.images.filter((img) => img.id !== imageId),
        })),

      setLoading: (isLoading) => set({ isLoading }),

      // Clear all cached data
      clearCache: () =>
        set({
          images: [],
          lastFetched: null,
          isLoading: false,
        }),
    }),
    {
      name: STORAGE_KEY,
      partialize: (state) => ({
        images: state.images,
        lastFetched: state.lastFetched,
      }),
    }
  )
);

export default useImageLibraryStore;
